import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants";
import { QUERY_CACHE } from "@/constants/constants.ts";

import type { CreateAccountsLinkableToTidQueryOptions } from "./types";

export function createAccountsLinkableToTidQueryOptions({
  getAccountsLinkableToTidFn,
  query,
  targetAccountId,
  tidTypeCode,
  enabled,
}: CreateAccountsLinkableToTidQueryOptions) {
  return queryOptions({
    queryKey: [
      queries.GET_ACCOUNTS_LINKABLE_TO_TID,
      query,
      targetAccountId,
      tidTypeCode,
    ],
    queryFn: () =>
      getAccountsLinkableToTidFn({ query, targetAccountId, tidTypeCode }),
    enabled,
    placeholderData: keepPreviousData,
    staleTime: QUERY_CACHE.SEARCH.STALE_TIME,
    gcTime: QUERY_CACHE.SEARCH.GC_TIME,
  });
}
